<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
    <span class="navbar-brand">
        <img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;">
    </span>
    <span class="headerSpace"></span>
    <span>
        <p *ngIf="this.helper.accountLoaded">Account : {{this.helper.accountList[this.helper.slectedAddress]}}</p>
    </span>
</nav>
<div class="main-div pb-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <h2 class="title">Create Wallet</h2>
                <div class="form-holder mb-4">
                    <h4 class="text-center text-white mt-4 font-weight-bold" style="font-style: italic">Please save these words in a secure place</h4>
                    <ul class="list-unstyled custom-wallet-list my-5" >
                        <li *ngFor="let word of seed">{{word}}</li>

                    </ul>
                    <!-- <div class="">
                        <mat-form-field class="example-full-width">
                            <input class="primary" matInput [(ngModel)]="seed">
                        </mat-form-field>
                    </div> -->
                    <div class="button-list my-4">
                        <button mat-stroked-button class="primary border-gradient-btn mb-2" (click)="regenerate()">Re-generate Seed Words</button>
                        <button mat-stroked-button class="primary border-gradient-btn mb-2" (click)="downloadAsText()">Download as Text File</button>
                        <!-- <button mat-stroked-button class="primary border-gradient-btn mb-2">Download CSV</button>
                            <button mat-stroked-button class="primary solid-gradient-btn mb-2">Print</button> -->
                        <!-- <button mat-stroked-button class="primary mb-2" (click)="goView(1)">back</button> -->
                    </div>

                </div>
                <div class="form-holder mb-4">
                    <div class="row justify-content-between">

                        <div class="col-md-6">
                            <mat-form-field class="example-full-width">
                                <input type="password" matInput class="primary" [(ngModel)]="passKey" placeholder="Set Wallet Access PIN">
                            </mat-form-field>
                            <mat-form-field class="example-full-width">
                                <input type="password" matInput class="primary" [(ngModel)]="confirmPassKey" placeholder="Confirm PIN">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <div class="gradient-box">
                                <div class="text-center">
                                    <img src="../../assets/images/exclamation-icon.png">
                                </div>

                                <p class="mt-3">Browser will remember your login session but you need to give this PIN every time you access
                                    account.
                                </p>
                            </div>
                            <!-- <button mat-stroked-button class="primary mb-2" (click)="confirmSeed()">Confirm</button> -->
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center py-4">
                        <button (click)="back()" mat-stroked-button class="primary solid-gradient-btn" >
                            Back
                        </button>
                        <button (click)="confirmSeed()" mat-stroked-button class="primary solid-gradient-btn" >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
